(() => {
'use strict';
if(window.buceFlowPolish)return;window.buceFlowPolish=true;

function blackNovember(){
 const deadline=Date.parse('2026-12-01T00:00:00-05:00');
 const main=document.getElementById('MainContent');
 if(!main||Date.now()>=deadline||!/^\/(?:$|collections(?:\/|$)|products(?:\/|$)|cart(?:\/|$))/.test(location.pathname)||document.getElementById('buce-november-countdown'))return;
 const banner=document.createElement('section');
 banner.id='buce-november-countdown';banner.className='buce-november-countdown';
 banner.setAttribute('aria-label','Black November. Descuentos hasta el 30 de noviembre de 2026, hora de Colombia.');
 const copy=document.createElement('div');copy.className='buce-november-countdown__copy';
 const badge=document.createElement('span');badge.className='buce-november-countdown__badge';badge.textContent='BLACK NOVEMBER';
 const title=document.createElement('strong');title.textContent='Estrena hoy por menos';
 const note=document.createElement('span');note.className='buce-november-countdown__note';note.textContent='Precios suben el 1 dic.';
 copy.append(badge,title,note);
 const clock=document.createElement('div');clock.className='buce-november-countdown__clock';clock.setAttribute('role','timer');clock.setAttribute('aria-live','off');
 const labels=['DÍAS','HORAS','MIN','SEG'];
 const numbers=labels.map(label=>{const box=document.createElement('span');box.className='buce-november-countdown__unit';const n=document.createElement('b');const l=document.createElement('small');l.textContent=label;box.append(n,l);clock.append(box);return n;});
 banner.append(copy,clock);
 const header=document.getElementById('shopify-section-header-inline');
 const identity=header?.querySelector('.buce-header-identity');
 const logo=identity?.querySelector('.t4s-header__logo');
 if(header&&identity&&logo){header.classList.add('buce-countdown-header','buce-countdown-integrated');banner.prepend(logo);identity.append(banner);}else main.prepend(banner);
 let interval;
 function tick(){
  const total=Math.max(0,Math.ceil((deadline-Date.now())/1000));
  if(total<=0){if(logo&&identity)identity.prepend(logo);banner.remove();header?.classList.remove('buce-countdown-header','buce-countdown-integrated');clearInterval(interval);return;}
  const values=[Math.floor(total/86400),Math.floor(total/3600)%24,Math.floor(total/60)%60,total%60];
  values.forEach((v,i)=>{const s=String(v).padStart(2,'0');if(numbers[i].textContent!==s)numbers[i].textContent=s;});
  clock.setAttribute('aria-label',values[0]+' días, '+values[1]+' horas, '+values[2]+' minutos y '+values[3]+' segundos restantes');
 }
 tick();interval=setInterval(tick,1000);
 document.addEventListener('visibilitychange',()=>{if(!document.hidden)tick();});
}

function recent(){
 const root=document.getElementById('t4s-search-hidden');
 const helper=root?.querySelector('.buce-search-helper');
 if(!root||!helper)return;
 helper.textContent='Busca por referencia o filtra por talla, marca y color.';
 const title=root.querySelector('.buce-finder-welcome h2');if(title)title.textContent='Encuentra tu favorito';
 let section=root.querySelector('.buce-search-viewed');
 if(!section){
  section=document.createElement('section');section.className='buce-search-viewed';section.setAttribute('aria-label','Vistos recientemente');
  const head=document.createElement('div');head.className='buce-search-viewed__head';
  const title=document.createElement('strong');title.textContent='Vistos recientemente';
  const clear=document.createElement('button');clear.type='button';clear.textContent='Limpiar';
  clear.addEventListener('click',()=>{try{localStorage.removeItem('buce:v2:recent');}catch{}section.hidden=true;document.querySelector('[data-buce-v2-recent]')?.setAttribute('hidden','');});
  head.append(title,clear);const rail=document.createElement('div');rail.className='buce-search-viewed__rail';
  section.append(head,rail);helper.after(section);
 }
 let items=[];try{const data=JSON.parse(localStorage.getItem('buce:v2:recent')||'[]');if(Array.isArray(data))items=data.filter(x=>x&&typeof x.handle==='string'&&Date.now()-Number(x.seenAt||0)<1209600000).slice(0,6);}catch{}
 const rail=section.querySelector('.buce-search-viewed__rail');rail.replaceChildren();
 items.forEach(item=>{
  const link=document.createElement('a');link.href='/products/'+encodeURIComponent(item.handle);
  if(item.image){try{const url=new URL(item.image,location.origin);if(url.protocol==='https:'&&(url.hostname===location.hostname||url.hostname==='cdn.shopify.com')){
   const image=document.createElement('img');image.src=url.href;image.alt='';image.loading='lazy';image.width=64;image.height=64;link.append(image);
  }}catch{}}
  const name=document.createElement('span');name.textContent=item.title||item.handle;link.append(name);rail.append(link);
 });
 section.hidden=items.length===0;
}
document.addEventListener('click',event=>{
 const button=event.target.closest('[data-sortby-item][data-value]');
 if(!button||!location.pathname.startsWith('/collections/'))return;
 const allowed=['manual','best-selling','title-ascending','title-descending','price-ascending','price-descending','created-ascending','created-descending'];
 const value=button.getAttribute('data-value');if(!allowed.includes(value))return;
 event.preventDefault();event.stopImmediatePropagation();
 const url=new URL(location.href);url.searchParams.set('sort_by',value);url.searchParams.delete('page');location.assign(url.href);
},true);
function start(){
 blackNovember();
 recent();
 const main=document.getElementById('MainContent');
 const fit=()=>{
  const note=main?.querySelector('.buce-cm__notice');
  if(note&&note.textContent!=='Compara tu plantilla: las medidas cambian según el modelo.')note.textContent='Compara tu plantilla: las medidas cambian según el modelo.';
  const value=main?.querySelector('[data-cm-value]');
  if(value&&value.textContent.trim()==='Elige una talla para ver su medida de plantilla.')value.textContent='Elige tu talla para ver los centímetros.';
  if(main?.querySelector('.buce-size-prompt'))main.querySelectorAll('button').forEach(button=>{
   if(button.textContent.trim()==='Escoge una opción'){
    const walker=document.createTreeWalker(button,NodeFilter.SHOW_TEXT);
    while(walker.nextNode())if(walker.currentNode.nodeValue.trim()==='Escoge una opción')walker.currentNode.nodeValue='Elige tu talla';
   }
  });
 };
 if(main){fit();new MutationObserver(fit).observe(main,{childList:true,subtree:true});}
 const drawer=document.getElementById('t4s-mini_cart');
 const savings=()=>drawer?.querySelectorAll('.buce-v9-savings dt').forEach(e=>{if(e.textContent.trim()==='Ahorro en productos')e.textContent='Ahorro total';});
 if(drawer){savings();new MutationObserver(savings).observe(drawer,{childList:true,subtree:true});}
 const root=document.getElementById('t4s-search-hidden');
 if(root)new MutationObserver(()=>{if(root.getAttribute('aria-hidden')==='false')recent();}).observe(root,{attributes:true,attributeFilter:['aria-hidden']});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();